import script from "./PayslipsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayslipsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PayslipsPage.vue?vue&type=style&index=0&id=3d330da3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d330da3"]])

export default __exports__